import { create } from 'zustand';
import { TActivityStore } from './domain';
import { DEFAULT_ACTIVITY_STATE } from './state';
import { getReviews } from '@/service/api/Reviews/getReviews';

const INIT_REVIEWS_COUNT = 4;
const MORE_REVIEWS_COUNT = 24;

export const useActivityStore = create<TActivityStore>((set, get) => ({
    ...DEFAULT_ACTIVITY_STATE,
    setOpenReviews: async (id, partnerSlug, count) => {
        if (get().activityId !== id) {
            if (!+count) {
                set({
                    showReviews: false,
                    reviewsLoading: false,
                    activityId: id,
                    partnerSlug,
                    reviews: [],
                });
            } else {
                set({
                    showReviews: true,
                    activityId: id,
                    partnerSlug,
                });

                const reviewsResp = await getReviews({
                    trip_id: id,
                    partner_id: partnerSlug,
                    /* activity_id: id, */
                    limit: INIT_REVIEWS_COUNT,
                    offset: 0,
                });

                set({
                    reviews: reviewsResp.items,
                });
            }
        }
    },
    loadMoreReviews: async (loadMore) => {
        if (!loadMore) {
            set((state) => ({
                ...state,
                reviewsLoading: false,
                reviews: state.reviews.slice(0, INIT_REVIEWS_COUNT),
                noMoreReviews: false,
            }));

            return;
        }

        set({ reviewsLoading: true });

        const reviewsResp = await getReviews({
            trip_id: get().activityId,
            partner_id: get().partnerSlug,
            /* activity_id: get().activityId, */
            limit: MORE_REVIEWS_COUNT,
            offset: get().reviews.length,
        });

        set((state) => ({
            ...state,
            reviewsLoading: false,
            reviews: [...state.reviews, ...reviewsResp.items],
            noMoreReviews: !reviewsResp.items.length,
        }));
    },
}));
